// src/components/newOperatorForm.js
import React, { useState, useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import { createOperator, getOperator, updateOperator } from "../api";

const NewOperatorForm = () => {
  const { t } = useContext(LanguageContext);
  const navigate = useNavigate();
  const { id_operator: routeId } = useParams();
  const isEdit = Boolean(routeId);

  const handleGoBack = () => navigate(-1);

  const company = JSON.parse(localStorage.getItem("company"));
  const id_c = company?.id_c;

  // 🔴 PRE-RELLENA con el param de la ruta
  const [form, setForm] = useState({
    id_operator: routeId || "",
    name_oper: "",
  });

  useEffect(() => {
    const load = async () => {
      if (!isEdit) return;

      // Si no hay id_c, igual muestra el id de la URL para que el user lo vea.
      if (!id_c || !routeId) {
        setForm(s => ({ ...s, id_operator: routeId || s.id_operator }));
        return;
      }

      const data = await getOperator(id_c, routeId);
      if (data) {
        setForm({
          id_operator: data.id_operator,          // viene de la BD
          name_oper: data.name_oper || "",
        });
      } else {
        // Si la API no devolvió nada, al menos deja el id de la URL
        setForm(s => ({ ...s, id_operator: routeId || s.id_operator }));
      }
    };
    load();
  }, [isEdit, id_c, routeId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((s) => ({ ...s, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (!id_c) throw new Error("id_c no encontrado");
      if (!form.id_operator.trim() || !form.name_oper.trim()) {
        alert(t("Campos obligatorios incompletos"));
        return;
      }

      if (isEdit) {
        await updateOperator(id_c, form.id_operator, { name_oper: form.name_oper.trim() });
        alert(t("Registro actualizado"));
      } else {
        await createOperator(id_c, {
          id_operator: form.id_operator.trim(),
          name_oper: form.name_oper.trim(),
        });
        alert(t("Registro creado"));
      }
      handleGoBack();
    } catch (error) {
      console.error("❌ Error guardando operador:", error);
      const msg = error?.response?.data?.message || error?.message || "";
      if (msg.includes("Duplicate") || msg.includes("duplic")) {
        alert(t("El operador ya existe para esta empresa"));
      } else {
        alert(t("Ocurrió un error al guardar"));
      }
    }
  };

  return (
    <div className="box1">
      <div className="box9">
        <form onSubmit={handleSubmit}>
          <table className="form1">
            <tbody>
              <tr>
                <td><label htmlFor="id_operator">{t("operator1")}</label></td>
                <td>
                  <input
                    className="input1"
                    id="id_operator"
                    name="id_operator"
                    value={isEdit ? (form.id_operator || routeId || "") : form.id_operator}
                    onChange={handleChange}
                    required
                    placeholder={t("Ej: OP-001")}
                    disabled={isEdit}   // en edición no se cambia el código
                  />
                </td>
              </tr>

              <tr>
                <td><label htmlFor="name_oper">{t("operator2")}</label></td>
                <td>
                  <input
                    className="input1"
                    id="name_oper"
                    name="name_oper"
                    value={form.name_oper}
                    onChange={handleChange}
                    required
                    placeholder={t("Nombre del operador")}
                  />
                </td>
              </tr>
            </tbody>
          </table>

          <button type="submit" className="button7">{t("prodList12")}</button>
          <button type="button" className="button7" onClick={handleGoBack} style={{ marginLeft: 8 }}>
            {t("prodList13")}
          </button>
        </form>
      </div>
    </div>
  );
};

export default NewOperatorForm;
